export function getAllRandomSamples(fileSize, duration) {
    return {
        "first": getRandomSample(fileSize, duration),
        "second": getRandomSample(fileSize, duration),
        "third": getRandomSample(fileSize, duration)
    };
}

function getRandomSample(fileSize, duration) {
    const tenSecondsBytes = (fileSize / duration) * 10;
    const startBytes = Math.random() * (fileSize - tenSecondsBytes - 1);
    return {
        start: Math.floor(startBytes),
        end: Math.min(Math.floor(startBytes + tenSecondsBytes), fileSize - 1)
    };
}